"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M18.354 8.646a.5.5 0 0 1 0 .708L10.5 17.207l-4.354-4.353a.5.5 0 0 1 .708-.708l3.646 3.647 7.146-7.147a.5.5 0 0 1 .708 0"
}), 'Check');
